module.exports = __webpack_public_path__ + "static/the-anatomy-of-disgust-6af82dec627307fb9918bf8b569b0913.jpg";